module.exports = __webpack_public_path__ + "img/doctor-notes.939933c6.svg";